import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  MatIconModule
} from '@angular/material/icon';
import {
  MatStepperModule
} from '@angular/material/stepper';
import {
  MatTabsModule
} from '@angular/material/tabs';
import {
  MatTooltipModule
} from '@angular/material/tooltip';
import {
  Router,
  RouterModule
} from '@angular/router';
import {
  ViewportScroller,
  NgClass,
  NgStyle
} from '@angular/common';

import { TFMService } from 'app/mock-api/tfm.service';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';

import { SearchComponent } from 'app/layout/common/search-widget/search.component';

@Component({
  selector: 'banner-type06',
  templateUrl: './banner-type06.component.html',
  styleUrls: ['./banner-type06.component.css'],
  standalone: true,
  imports: [
    MatIconModule,
    MatTabsModule,
    MatStepperModule,
    MatTooltipModule,
    RouterModule,
    NgClass,
    NgStyle,
    SearchComponent,
  ],
})
export class BannerType06Component implements OnInit {

  @Output() widgetChange = new EventEmitter<boolean>();

  @Input('options') public _options: any;
  @ViewChild('thomalexWidget') thomalexWidgetRef: ElementRef;

  public backgroundImages: string[] = [];
  public selectedTab: string = 'flight';

  isThomalexWidget = false;
  isThomalexLoading = false;
  showThomalexModal = false;
  thomalexInitialized = false;
  thomalexUrl = 'https://xlmstellenbosch.resvoyage.com/airtravel.htm?lang=en-US&rest=false#';
  // https://xlmstellenbosch.resvoyage.com/airtravel.htm?lang=en-US&rest=false# (Widget link for reference)
  // https://xlmstellenbosch.resvoyage.com/widget/index?widgetId=6c993083-090c-4b01-9e7c-39b53f4ca343&lang= (old stellies link)

  public view: any = {
    selectedTab: 'flight',
    currentImageIndex: 0,
    activeLayer: 1
  };

  constructor(
    private _tfmCartService: TFMCartService,
    private _cd: ChangeDetectorRef,
    private _router: Router,
    private _tfmService: TFMService,
    private scroller: ViewportScroller
  ) { }

  ngOnInit(): void {
    this.view.options = 'multicity';
    this.loadSiteAndImages();
  }

  toggleWidget() {
    this.isThomalexWidget = !this.isThomalexWidget;
    this.widgetChange.emit(this.isThomalexWidget);
    this._cd.detectChanges();
  }

  loadSiteAndImages(): void {
    this._tfmService.getSite().then(site => {
      this.view.site = site;

      this._tfmService.filterAndSend(site._links, 'site-images').subscribe(res => {
        const images = res.content;
        images.forEach(img => {
          const imgLink = this._tfmService.getLink(img._links, 'view');
          if (imgLink?.href) {
            img.url = imgLink.href;
            this.backgroundImages.push(img.url);
          }
        });

        this.view.imageLayer1 = this.backgroundImages[0];
        this.view.activeLayer = 1;

        this.startSlideshow();
      });
    });
  }

  selectTab(tab: string): void {
    this.view.selectedTab = tab;
    this._cd.detectChanges();
  }

  ngAfterViewChecked(): void {
    if (!this.thomalexInitialized && this.thomalexWidgetRef?.nativeElement && this.view?.site?.id === 79 && this.view?.selectedTab === 'flight') {
      this.thomalexInitialized = true;
      this.loadThomalexScript();
    }
  }

  loadThomalexScript() {
    const existingScript = document.querySelector('script[src*="thomalex-integration.js"]');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.src = 'https://xlmstellenbosch.resvoyage.com/scripts/thomalex-integration.js';
    script.async = true;
    script.onload = () => {
      this.observeWidgetContent();
    };
    document.body.appendChild(script);
  }

  observeWidgetContent() {
    const widgetEl = this.thomalexWidgetRef?.nativeElement;
    if (!widgetEl) return;

    const observer = new MutationObserver(() => {
      const hasContent = widgetEl.innerHTML.trim().length > 0;
      if (hasContent) {
        this.isThomalexLoading = false;
        observer.disconnect();
      }
    });

    observer.observe(widgetEl, {
      childList: true,
      subtree: true,
    });

    // Fallback in case MutationObserver doesn’t fire
    setTimeout(() => {
      this.isThomalexLoading = false;
      observer.disconnect();
    }, 2000);
  }

  onScrollToAnchor(): void {
    this.scroller.scrollToAnchor('destination-section');
  }

  tripChanged(tripData: any): void {
    this.view.trip = tripData;
    this._tfmCartService.updateTrip(tripData);
    this.redirectToResults();
  }

  searchChanged(searchData: any): void {
    this.view.search = searchData;
    this.redirectToResults();
  }

  resultChanged(): void {
    // Placeholder for future logic
  }

  redirectToResults(): void {
    if (this.view.trip && this.view.search) {
      this._router.navigateByUrl('/search-results', {
        state: {
          view: this.view,
          type: this.view.selectedTab,
        },
      });
    }
  }

  startSlideshow(): void {
    setInterval(() => {
      const nextIndex = (this.view.currentImageIndex + 1) % this.backgroundImages.length;
      const nextImage = this.backgroundImages[nextIndex];

      this.fadeToImage(nextImage);
      this.view.currentImageIndex = nextIndex;
    }, 5000);
  }

  fadeToImage(nextImage: string): void {
    const img = new Image();
    img.src = nextImage;

    img.onload = () => {
      if (this.view.activeLayer === 1) {
        this.view.imageLayer2 = nextImage;
        this.view.activeLayer = 2;
      } else {
        this.view.imageLayer1 = nextImage;
        this.view.activeLayer = 1;
      }
      this._cd.detectChanges();
    };
  }

  get currentImage(): string {
    return this.backgroundImages[this.view.currentImageIndex];
  }
}
